<template>
  <div>
    <v-card>
      <v-toolbar
        color
        class="mb-1"
        :style="{
          'background-color': getThemeColor,
          color: getSecondaryColor,
        }"
      >
        <v-toolbar-title>2. Select Staff From List</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch
          dark
          v-model="employeesSwitch"
          class="mt-6 mr-2"
          label="All"
          @change="handleEmployeesSwitch()"
        ></v-switch>

        <v-icon @click="deleteSelectedEmployees()" color="red"
          >mdi-delete</v-icon
        >
      </v-toolbar>

      <v-virtual-scroll :items="employees" height="600" item-height="130">
        <template v-slot:default="props">
          <v-list two-line>
            <v-list-item :key="props.index + Math.random()">
              <v-list-item-content>
                <v-list-item-title v-text="props.item.name"></v-list-item-title>
                <v-list-item-title
                  v-text="'ID: ' + props.item.id_number"
                ></v-list-item-title>
                <v-list-item-title
                  v-text="'Phone: ' + props.item.phone"
                ></v-list-item-title>
                <v-list-item-title
                  v-text="
                    'Address: ' + props.item.address + ', ' + props.item.city
                  "
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-checkbox
                  class="shrink"
                  :value="props.item.id"
                  v-model="selectedStaffIDs"
                  @click="getSelectedStaffIDs"
                ></v-checkbox>

                <v-btn
                  @click="getEmployeeProfile(props.item)"
                  fab
                  :style="getThemeStyle"
                  x-small
                  dark
                  ><v-icon>mdi-account</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </template>
      </v-virtual-scroll>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    employees: {
      default: () => [],
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  data: () => ({ employeesSwitch: false, selectedStaffIDs: [] }),
  methods: {
    handleEmployeesSwitch() {
      if (this.employeesSwitch) {
        this.selectedStaffIDs = [];
        this.employees.forEach((staff) => {
          this.selectedStaffIDs.push(staff.id);
        });
      } else {
        this.selectedStaffIDs = [];
      }
      this.$emit("selected-staff-from-staff-list", this.selectedStaffIDs);
    },
    getSelectedStaffIDs() {
      this.$emit("selected-staff-from-staff-list", this.selectedStaffIDs);
    },
    deleteSelectedEmployees() {
      if (this.selectedStaffIDs.length < 1) {
        alert("Select Aleast 1 Staff");
        event.preventDefault();
      } else {
        this.$store.commit("setGlobalConfirmDelete", true);
      }
    },
    getEmployeeProfile(item) {
      this.$emit("employee-profile-selected", item);
    },
    openApplySalaryDialog() {
      //console
    },
  },
};
</script>
